export const ADD_EARNINGS = "ADD_EARNINGS";
export const GET_EARNINGS = "GET_EARNINGS";
export const CLEAR_EARNINGS = "CLEAR_EARNINGS";
export const GET_PRIVATE_EARNINGS = "GET_PRIVATE_EARNINGS";
export const GET_DRIVER_EARNINGS = "GET_DRIVER_EARNINGS";
export const UPDATE_EARNINGS = "UPDATE_EARNINGS";
export const UPDATE_EARNING = "UPDATE_EARNING";
export const IS_DRAFT = "IS_DRAFT";
